<template>
  <div class="container py-4">
    <!-- Giriş Alanları -->


    <!-- Belge Alanı -->
    <div ref="captureArea" class="main">


      <div class="header">
        <h4>VEFAT DUYURUSU</h4>



      </div>
      <div class="message">
      </div>

     
      <div class="footer">
     
        <h3 class="dernek_name">Başkent Ağrılılar Derneği</h3>

      </div>
      <img src="/img/logo.jpg" alt="Dernek Logosu" class="logo" />
    </div>

    <!-- İndirme Butonu -->
    <div class="text-center mt-4">
      <button @click="downloadAsPng" class="btn btn-success">
        PNG Olarak Kaydet
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import html2canvas from "html2canvas";
const captureArea = ref(null);

const downloadAsPng = async () => {
  if (!captureArea.value) return;

  const canvas = await html2canvas(captureArea.value, {
    backgroundColor: "#1a1a1a",
    scale: 2,
    useCORS: true,
  });

  const link = document.createElement("a");
  link.download = "taziye-belgesi.png";
  link.href = canvas.toDataURL("image/png");
  link.click();
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap");

.main {
  position: relative;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  border-radius: 12px;
  background: #1a1a1a;
  color: #f5f5f5;
  font-family: "Poppins", sans-serif;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
}

.header {
  background-color: gray;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 12px;
}

.header h4 {
  color: black;
}

.message {
  height: 200px;
}
.logo{
position: absolute;
bottom: 12px;
left: 12px;
border-radius: 50%;
}

.footer{
display: flex;
flex-direction: row;
background-color: gray;
padding: 12px;
align-items: center;
color: white;
}
.dernek_name{
  padding-left: 120px;
}

</style>
